module.exports = __webpack_public_path__ + "Roboto-Light.69f8a0617ac472f78e45.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Light.woff2
// module id = ../../../../../font/roboto/Roboto-Light.woff2
// module chunks = styles